import React from 'react';
import { SectionHeading, smallInputCls, checkCls } from './ui.jsx';

export default function CalendarConnectSection({
  email, saveToCalendarId, setSaveToCalendarId,
  busyDuringCalendars, setBusyDuringCalendars,
  markUnavailableAllDay, setMarkUnavailableAllDay,
}) {
  return (
    <div className="p-6 space-y-4 border-b border-white/10">
      <SectionHeading title="Connect Calendar" />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-1">
          <label className="block text-xs font-semibold text-white/70">
            Select calendar to save appointments to <span className="text-rose-400">*</span>
          </label>
          <select
            id="select-calendar"
            name="addEventsToCalendarId"
            value={saveToCalendarId}
            onChange={(e) => setSaveToCalendarId(e.target.value)}
            className={smallInputCls}
          >
            <option value={email}>{email} (Google Calendar)</option>
            <option value="civix-primary">CIVIX Internal Calendar</option>
            <option value="outlook-primary">Outlook Calendar</option>
          </select>
        </div>

        <div className="space-y-1">
          <label className="block text-xs font-semibold text-white/70">
            Mark me as busy for events on these calendars <span className="text-rose-400">*</span>
          </label>
          <select
            id="select-calendar-to-pull-events"
            name="busyDuringGoogleCalendars"
            value={busyDuringCalendars}
            onChange={(e) => setBusyDuringCalendars(e.target.value)}
            className={smallInputCls}
          >
            <option value={email}>{email} (Google Calendar)</option>
            <option value="civix-primary">CIVIX Internal Calendar</option>
          </select>
        </div>
      </div>

      <label
        data-testid="mark-busy-all-day-calendar-events"
        className="flex items-center gap-2 text-xs text-white/80 cursor-pointer"
      >
        <input
          type="checkbox"
          checked={markUnavailableAllDay}
          onChange={(e) => setMarkUnavailableAllDay(e.target.checked)}
          className={checkCls}
        />
        <span>Mark me as unavailable during all-day Calendar events.</span>
      </label>
    </div>
  );
}
